import { FiEdit } from "react-icons/fi";
import { LuTrash2, LuBadgeCheck } from "react-icons/lu";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { modalActions } from "../../store/modalSlice";
import { userActions } from "../../store/userSlice";
import { userDetailsActions } from "../../store/userDetailsSlice";

export const tBodyItemStyle = {
    padding: '12px 20px',
    borderBottom: '1px solid #eee',
}

export const tBodyRowStyle = {
    height: '80px',
    cursor: 'pointer'
}

function capitalizeFirstLetter(string) {
    if (!string) return '';
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export default function UserListItem({ user, actions = true }) {

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const handleRowClick = () => {
        dispatch(userDetailsActions.openModal(user))
        return;
        if (!actions) {
            return
        }
        navigate(`/users/${user.id}/edit`)
        dispatch(userActions.fillUser({ user: user }))
    }

    const handleUserEditClick = (e) => {
        // e.stopPropagation();
        // dispatch(userActions.fillUser({ user: user }))
    }

    const handleUserDeleteClick = (e) => {
        e.stopPropagation();
        dispatch(modalActions.openModal(
            {
                details:
                {
                    id: user.id,
                    name: user.user_type === 'individual' ? `${user.first_name} ${user.last_name}` : user.company_name,
                    category: 'user'
                }
            }))
    }

    return (
        <>
            <tr className="table_row" onClick={handleRowClick}>
                <td style={tBodyItemStyle} className="text-black font-medium w-[10%]">{user.id}</td>
                <td style={tBodyItemStyle} className="text-black font-medium w-[20%]">
                    <div className="flex gap-2 items-center">
                        {user.first_name} {user.last_name}
                        {Number(user.registry_verified) === 1 && <LuBadgeCheck color="#ddd" fontSize={16} title="Verified" />}
                    </div>
                </td>
                <td style={tBodyItemStyle} className="text-black font-medium w-[20%]">{new Date(user.created_at).toLocaleString('en-GB')}</td>
                <td style={tBodyItemStyle} className="w-[15%]">{user.phone_number}</td>
                <td style={tBodyItemStyle} className="w-[20%]">{user.email}</td>
                <td style={tBodyItemStyle} className="w-[10%]">{capitalizeFirstLetter(user.role)}</td>
            </tr>
        </>
    )
}